import { Button } from "../Buttons";

const NavTabs = ({ tabArray, activeTab, activeTabHandler, className = "" }) => {
  return (<div className={`flex gap-[12px] ${className}`}>
    {tabArray?.map((nav, index) =>
      <Button variant="secondary"
        onClick={() => activeTabHandler(index + 1)}
        className={` text-primary font-Apparat border-[2px] ${index + 1 == activeTab ? ' border-primary' : 'border-[#78666926]'}`}
        title={nav.label}
      />

      //   <h4 key={index}
      //   className={`font-Apparat font-[700] cursor-pointer text-[20px] tracking-[-2%] leading-[24px] ${index + 1 == activeTab ? 'text-[#262626]' : 'text-[#26262659]'}`}
      //   onClick={() => activeTabHandler(index + 1)}
      // >{nav.label}</h4>
    )}
  </div>)
}
export default NavTabs;